import { Button } from '@depop/web-thrift-ui/Button';

import { type AdminToolIcon } from '@/modules/adminTool/types';

type Props = {
  icon: AdminToolIcon;
  label: string;
  onClick: () => void;
};

export function ToolButton({ label, icon, onClick }: Props) {
  return (
    <Button variant="secondary" onClick={onClick} icon={icon}>
      {label}
    </Button>
  );
}
